import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NavigateHeaderProps as Props } from './types';

export const EnrichmentNavigateHeader = memo(({ className }: Props) => {
  const navigate = useNavigate();

  return (
    <Styled.Wrapper
      className={classnames('NavigateHeader', className)}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={SX.root}
    >
      <Button sx={SX.text} onClick={() => navigate(-1)}>
        <Icon name="arrow-left-fill" size={14} />
        Back
      </Button>
      <Stack direction="row" gap={0.5}>
        <Typography sx={SX.count}>3</Typography>
        <Typography sx={SX.text}>Results</Typography>
      </Stack>
    </Styled.Wrapper>
  );
});

EnrichmentNavigateHeader.displayName = 'EnrichmentNavigateHeader';
